import moment from 'moment';

export default function friendlyDateTime(value) {
  return moment(value).format('MMM D HH:mm');
}
